import { Component, ViewChild, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../service/events/dashboard.service';
import { environment } from '../../../environments/environment';
import { StorageManager } from '../../common/storage-manager.class';
import { LoginApiService } from '../../service/api/login-api.service';

import { InputType, type ItemInterface, } from '../../common/components/form-builder/form-builder.component';
import { AppFormRequest } from '../app-common/form-request/app-form-request';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { list } from '../../common/classes/request-builder';
import moment from 'moment';
import { UserActivityApiService } from '../../service/api/user_activity-api.service';
import SignaturePad from 'signature_pad';
import { UploadApiService } from '../../service/api/upload-api.service';
import { ProductosApiService } from '../../service/api/productos-api';
import { FormCommonApiService } from '../../service/api/formcommon-api.service';
import { FincasApiService } from '../../service/api/fincas-api.service';
import { MenuItemModel } from '../../models/menu-item';
import { catchError, firstValueFrom, map, of, Subject, takeUntil } from 'rxjs';
import { BaseResponseModel } from 'src/app/models/base-response.model';
import { AnuncioModel } from 'src/app/models/anuncio.model';
import { TieredMenu } from 'primeng/tieredmenu';
import { FileUploadAnswer } from 'src/app/common/utils';
import { VademecumActivity } from 'src/app/models/usuarios/vademecum-activity';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { Uso } from 'src/app/models/productos/uso.model';

import { createChat } from '@n8n/chat';
import { NavigationService } from 'src/app/service/navigation.service';
import { NavbarComponent } from './navbar/navbar.component';
import { SubcellClick } from './sidenav-cell/sidenav-cell.component';
@Component({
    selector: 'app-dashboard',
    standalone: false,
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    providers: [ MessageService ],
})
export class DashboardComponent implements OnInit {
    
    @ViewChild('signaturePadElement', { static: true })
    signaturePadElement!: SignaturePad;

    public currentUser = this.loginApi.getCurrentUser();

    public currentClient = StorageManager.getClient();

    public appName = environment.appName;

    public applicationType = environment.features.applicationType;

    public logoUrl = environment.features.hasHorizontalLogo ?
        environment.logoUrl.replace(/(\.[a-z]+)$/, '_horizontal$1') :
        environment.logoUrl;

    public serverUrl = environment.serverUrl;

    public urlLogoLocatec =
        environment.serverUrl + 'assets/logo-locatec-footer.png';

    public showWatermark = environment.features.showWatermark;

    public showPerfilUnidades = environment.features.showPerfilUnidades;

    public showPerfilFincas = environment.features.showPerfilFincas;

    public sdiModuleActive = environment.features.sdiModuleActive;

    public clienteName = environment.features.clienteName;

    public clientesName = environment.features.clientesName;

    public hasClients = environment.features.hasClients;

    public showBackup = environment.features.showBackup;

    public showVademecumActivity = environment.features.showVademecumActivity;

    public clientesMostrarTodosDefault =
        environment.features.clientesMostrarTodosDefault;

    public showUsuariosFirma = environment.features.showUsuariosFirma;

    public urlBlackList = environment.features.urlBlackList;

    public urlRedirect = environment.features.urlRedirect;

    public showVademecumListadoProductos =
        environment.features.showVademecumListadoProductos;

    public userCanSeeClientes = environment.features.userCanSeeClientes
        ? true
        : this.currentUser.rol === 'admin' ||
        this.currentUser.rol === 'responsable';

    public showUsuariosLogs = environment.features.showUsuariosLogs;

    public hasSignature = false;

    public modelSignature: string | null = null;

    public urlSignature =
        this.serverUrl +
        'firmas_usuarios/' +
        (StorageManager.getUser().id || 0) +
        '.png';

    public signaturePadOptions: object = {
        minWidth: 1,
        canvasWidth: 300,
        canvasHeight: 150,
        allowTaint: true,
    };

    // Este comentario es mejor
    public clientHeaderDialog = '';

    public showClientDialog = false;

    public showAdvertisingForm = false;

    public anuncioTexto = '';

    public anuncioImagen: string | ArrayBuffer | null | undefined = null;

    public mostrarAnuncioEmergente = false;

    public showBackupDialog = false;

    public showVademecumDialog = false;

    public showVademecumListadoDialog = false;

    public hasAutocompleted = false;

    public isDownloadingCsv = false;

    public isGeneratingCsv = false;

    public charset = 'windows-1252';

    public visibleItems = 0;

    public validationErrors = '';

    public userActivity: VademecumActivity[] = [];

    public formRequest = new AppFormRequest<VademecumActivity>();

    public fechaEdited = false;

    public actualizando = false;

    public isOnline = false;

    public fincas = list(['...', null]);

    public unidades = list('Hectáreas', 'Hanegadas', 'Taullas');

    public listadoProductos: {
        id?: null | string;
        referencias?: string;
        productos?: string[];
    } = {
            id: null,
            referencias: '',
            productos: [''],
        };

    public productosCSV = StorageManager.getListadoProductosCSV();

    public cabecerasCSV = '';

    public isComunero = false;

    iconRefresh = 'fa fa-refresh';
    /** Shared dialog breakpoints & styles (reused across p-dialogs) */
    public readonly dialogBreakpoints = { '1199px': '75vw', '575px': '90vw' } as const;
    
    public readonly menuBtnStyle: Record<string, string> = { color: 'white'};
    
    public readonly infoBtnStyle: Record<string, string> = { width: '24px', height: '24px'};

    public formFields: ItemInterface<object>[] = [
        {
            label: 'Nombre/Razón social',
            field: 'nombre',
            inputType: { type: InputType.EDIT_TEXT },
        },
        {
            label: 'Apellidos',
            field: 'apellidos',
            inputType: { type: InputType.EDIT_TEXT },
        },
        {
            label: 'Tipo de carnet',
            field: 'tipo_carnet',
            inputType: { type: InputType.DROPDOWN },
            values: list(
                ['...', null],
                'BÁSICO',
                'CUALIFICADO',
                'FUMIGADOR',
                'PILOTO',
                'ASESOR'
            ),
        },
        {
            label: 'Fecha de caducidad',
            field: 'fecha_caducidad',
            inputType: { type: InputType.CALENDAR },
        },
        {
            label: 'CIF/NIF',
            field: 'nif',
            inputType: { type: InputType.EDIT_TEXT },
        },
        {
            label: 'ROPO',
            field: 'ropo',
            inputType: { type: InputType.EDIT_TEXT },
        },
        {
            label: 'IMEI',
            field: 'imei',
            inputType: { type: InputType.EDIT_TEXT },
            visible: environment.appName === 'manezylozano',
        },
        {
            label: 'Tipo de mando',
            field: 'tipo_mando',
            inputType: { type: InputType.DROPDOWN },
            values: list(
                ['...', null],
                'SISTRONIC',
                'TRONIC',
                'SISTROMATIC',
                'OZONO'
            ),
            visible: environment.appName === 'manezylozano',
        },
    ];

    public formFields2: ItemInterface<object>[] = [
        {
            label: 'Unidad de medida',
            field: 'uds_medida',
            inputType: { type: InputType.DROPDOWN },
            values: this.unidades,
            visible: this.showPerfilUnidades,
        },
        {
            label: 'Relación con una Hectáreas',
            field: 'ratio_ha',
            inputType: { type: InputType.EDIT_NUMERIC },
            placeholder: '1 Hectáreas = X unidades',
            visible: this.showPerfilUnidades,
        },
        {
            label: 'Finca asociada',
            field: 'id_finca',
            valuePrimaryKey: 'id',
            inputType: { type: InputType.DROPDOWN },
            values: this.fincas,
            visible: this.showPerfilFincas,
        },
    ];

    public header: {
        title: string;
        subtitle: string;
    } = { title: 'Inicio', subtitle: '' };

    public auxContador = 0;

    navbarComponent = new NavbarComponent();

    private readonly destroy$ = new Subject<void>();

    constructor(
        public router: Router,
        public dashboardEvent: DashboardService,
        private readonly userActivityApi: UserActivityApiService,
        private readonly loginApi: LoginApiService,
        private readonly fincasApi: FincasApiService,
        public http: HttpClient,
        private readonly messageService: MessageService,
        private readonly uploadApi: UploadApiService,
        public productosApi: ProductosApiService,
        private readonly formApi: FormCommonApiService,
        public readonly navigationService: NavigationService
    ) { 
        void this.dashboardEvent;
        void this.router;
    }

    public static createNavigation(router: Router, route: string = 'inicio'): void {
        router.navigate(['dashboard', route]);
    }

    ngOnInit(): void {
        this.visibleItems = this.dashboardEvent.menuItemData.filter(it => it.visible).length;
        this.isComunero = StorageManager.getUser().tipo === 'comunero';


        const menu = this.dashboardEvent.menuItemData;

        switch (environment.appName) {
        case 'donjardin': {
            // Rule: “tareas” must be at position #3 (index 2)
            this.moveKeyToIndex(menu, 'tareas', 2);
            break;
        }

        case 'avafitogest': {
            // Rule: apply full, explicit order; any missing/extra items go after these.
            const ORDER_AVA = [
            'usuarios',
            'clientes',
            'fincas',
            '_aplicadores',
            'compradores',
            'tareas',
            'analisis',
            'ventas',
            'consultas',
            'productos',
            'tratamientos',
            'mapas-section',
            'calendario',
            ];

            this.reorderByKeys(menu, ORDER_AVA);
            break;
        }

        case 'coliberica': { 
            this.moveKeyToIndex(menu, 'tareas', Number.POSITIVE_INFINITY);
            break;
        }

        default:
            // No reordering for other apps
            break;
        }

        switch(environment.features.applicationType) {
            case 'agrogest':
            case 'viverogest':
                const ORDER_AGROGEST = [
                    'usuario',
                    'clientes',
                    'cliente',
                    'fincas',
                    '_aplicadores',
                    'compradores',
                    'analisis',
                    'mapas-section',
                    'consultas',
                    'productos',
                    'tratamientos',
                    'tareas',
                    'calendario-tareas',
                    'calendario',
                    'stock',
                    'ventas',
                    'costes'
                ];

                this.reorderByKeys(menu, ORDER_AGROGEST);
                break;
        }

        if (this.sdiModuleActive) {
            firstValueFrom(
                this.http.get(this.serverUrl + 'ws/sdi/update/clientes_update.php')
            )
                .then(() => {
                    console.log('Clientes actualizados desde el ERP.');
                    return;
                })
                .catch((e) => {
                    console.log('catch en getPosition: ' + e);
                });
            firstValueFrom(
                this.http.get(this.serverUrl + 'ws/sdi/update/productos_update.php')
            )
                .then(() => {
                    console.log('Productos actualizados desde el ERP.');
                    return;
                })
                .catch((e) => {
                    console.log('catch en getPosition: ' + e);
                });
        }

        if (this.appName === 'agroleza' && this.currentUser.rol === 'user') {
            firstValueFrom(
                this.http.get<BaseResponseModel<AnuncioModel>>(
                    `${this.serverUrl}ws/index.php?p1=generic&p2=anuncios`
                )
            )
                .then((result) => {
                    if (((result.data as AnuncioModel[])[0]?.imagen) != null) {
                        this.anuncioImagen =
                            (result.data as AnuncioModel[])[0]?.imagen ?? '';
                        this.anuncioTexto = (result.data as AnuncioModel[])[0]?.texto ?? '';
                    }

                    this.mostrarAnuncioEmergente = true;
                    return;
                })
                .catch((e) => {
                    console.log('catch en getPosition: ' + e);
                });
        }
        this.formRequest.setFormFields(this.formFields.concat(this.formFields2));

        this.setOnlineService();
        if (this.showPerfilFincas) {
            this.initFincas();
        }

        this.dashboardEvent.onProfileChanges()
        .pipe(takeUntil(this.destroy$))
        .subscribe((open: boolean): void => {
            if (open) {
                this.navbarComponent.showClientProfile.set(true);
            } else {
                this.navbarComponent.showClientProfile.set(false);
            }
        });

        if (environment.features.hasClients) {
            if (!(Boolean(StorageManager.getClient()))) {
                this.navbarComponent.showClientDialog = environment.appName !== 'gruesnadal';
            }
        }

        this.mountN8nChatIfNeeded();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

 
    /** Track menu items by stable id to avoid re-rendering */
    public trackByMenuId(_i: number, item: MenuItemModel): string {
        return item.id;
    }

    public onNavItemClick(id: string): void {
        this.dashboardEvent.onMenuItemClick(id);
        // this.navigationService.sidebarCollapsed.set(!this.navigationService.sidebarCollapsed());
    }

    public onSubNavItemClick(ev: SubcellClick): void {
        this.navigationService.sidebarCollapsed.set(!this.navigationService.sidebarCollapsed());
        this.dashboardEvent.onSubmenuItemClick(ev.fatherId, ev.submenuId);
    }

    public toggleMenu(menu: TieredMenu, triggerEl: HTMLElement): void {
        menu.toggle({ currentTarget: triggerEl } as any);

        setTimeout(() => {
            const menuEl = document.querySelector('.p-tieredmenu') as HTMLElement;
            
            if (menuEl !== null && triggerEl !== null) {
                const rect = triggerEl.getBoundingClientRect();
                const TOP_DEVIATION = 8;
                
                menuEl.style.position = 'fixed';
                menuEl.style.top = `${rect.bottom + TOP_DEVIATION}px`;
                menuEl.style.left = `${rect.right - menuEl.offsetWidth}px`;
                menuEl.style.right = 'auto';
                menuEl.style.zIndex = '9999';
            }
        }, 0);
    }

    public closeClientDialog(): void {
        this.showClientDialog = false;
        this.clientHeaderDialog = 'Cambiar ' + this.clienteName;
    }

    public closeClientProfile(): void {
        this.navbarComponent.showClientProfile.set(false);
        this.currentUser = StorageManager.getUser();
    }

    public closeAdvertisingForm(): void {
        this.showAdvertisingForm = false;
    }

    public closeBackupDialog(): void {
        this.showBackupDialog = false;
    }

    public saveProfileEdit(): void {
        if (!this.validateForm()) {
            alert(this.validationErrors);
            return;
        }

        this.actualizando = true;

        const headers = new HttpHeaders();
        
        headers.append('Content-Type:', 'application/json');
        headers.append('Request-Method', 'PUT');

        if (this.isComunero) {
            delete this.currentClient?.tipo_carnet;

            firstValueFrom(
                this.http.put(
                    `${this.serverUrl}ws/index.php?p1=generic&p2=clientes&p3=${this.currentUser.id}`,
                    JSON.stringify(this.currentClient),
                    { headers: headers }
                )
            )
                .then(() => {
                    StorageManager.saveClient(this.currentClient);
                    this.actualizando = false;
                    this.navbarComponent.showClientProfile.set(false);
                    this.showSuccess();
                    return;
                })
                .catch((e) => {
                    console.log('catch en getPosition: ' + e);
                });
        } else {
            if (this.fechaEdited) {
                this.currentUser.fecha_caducidad = moment(
                    this.currentUser.fecha_caducidad
                ).format('DD/MM/YYYY');
                this.fechaEdited = false;
            }

            firstValueFrom(
                this.http.put(
                    `${this.serverUrl}ws/index.php?p1=generic&p2=usuarios&p3=${this.currentUser.id}`,
                    JSON.stringify(this.currentUser),
                    { headers: headers }
                )
            )
                .then(() => {
                    StorageManager.saveUser(this.currentUser);
                    this.actualizando = false;
                    this.navbarComponent.showClientProfile.set(false);
                    this.showSuccess();
                    return;
                })
                .then(() => {
                    if (this.showUsuariosFirma) {
                        this.uploadApi.firmasPOST.toPromise({
                            id: StorageManager.getUser().id,
                            dir: 'firmas_usuarios',
                            firma: this.modelSignature ?? '',
                        });
                    }
                    return;
                })
                .catch((e) => {
                    console.log('catch en getPosition: ' + e);
                });
        }
    }

    public postAdvertisement(): void {
        const headers = new HttpHeaders();
        
        headers.append('Content-Type:', 'application/json');
        headers.append('Request-Method', 'POST');

        const anuncio = {
            imagen: this.anuncioImagen,
            texto: this.anuncioTexto,
        };
        
        firstValueFrom(
            this.http.post(
                `${this.serverUrl}ws/index.php?p1=generic&p2=anuncios`,
                JSON.stringify(anuncio),
                { headers: headers }
            )
        )
            .then(() => {
                this.showAdvertisingForm = false;
                this.showSuccess();
                return;
            })
            .catch((e) => {
                console.log('catch en getPosition: ' + e);
            });
    }

    public fileChange(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const fileList: FileList = input.files;
            
            if (fileList.length > 0) {
                const file: File = fileList[0] ?? new File([], '');
                const formData: FormData = new FormData();
               
                formData.append('uploadFile', file, file.name);
                const headers = new HttpHeaders();
                
                headers.append('Content-Type', 'multipart/form-data');
                headers.append('Accept', 'application/json');

                const name: string[] = file.name.split('.');
                const ext = name[name.length - 1];
                const accepted = ['gif', 'jpeg', 'jpg', 'jiff', 'png', 'svg', 'tiff'];
                let cond = false;

                for (const e of accepted) {
                    if (e === ext) {
                        cond = true;
                    }
                }

                if (cond) {
                    this.http
                        .post<FileUploadAnswer>(
                            `${environment.serverUrl}ws/recordatorio/upload_file.php`,
                            formData,
                            { headers: headers }
                        )
                        .pipe(
                            map((data) => {
                                const res = data;
                                
                                this.anuncioImagen = res.fileName;
                            }),
                            catchError((error) => {
                                console.log(error);
                                return of(null);
                            })
                        )
                        .subscribe();
                } else {
                    alert('Formato de imágen no válido.');
                    this.anuncioImagen = '';
                }
            }
        }
    }

    // Adjuntos
    public readUrl(input: HTMLInputElement): void {
        input.click();
        if (input.files?.[0]) {
            const reader = new FileReader();
            
            reader.onload = (e): void => {
                this.anuncioImagen = e.target?.result ?? '';
            };
            reader.readAsDataURL(input.files[0]);
            const r = this.http
                .post<FileUploadAnswer>(
                    environment.serverUrl + 'ws/recordatorio/upload_file.php',
                    this.anuncioImagen
                )
                .subscribe((res) => {
                    const file = res;
                    
                    this.anuncioImagen = file.fileName;
                    r.unsubscribe();
                });
        }
    }

    public verAdjunto(): void {
        const myWindow = window.open(
            'about:blank',
            '_blank',
            'width=600, height=600'
        );

        myWindow?.location.assign(
            environment.serverUrl + 'imagenes_publicitarias/' + this.anuncioImagen
        );
        myWindow?.focus();
    }

    public downloadBackup(): void {
        this.isDownloadingCsv = true;

        const headers = new HttpHeaders();

        headers.append('Content-Type:', 'application/json');
        headers.append('Request-Method', 'POST');

        const formdata = new FormData();
        const auth1 =
            this.currentUser.id +
            '_' +
            this.currentUser.nombre +
            '_' +
            window.btoa('admin');
        const auth2 = window.btoa(auth1);

        formdata.append('user', JSON.stringify(this.currentUser));
        formdata.append('auth', auth2);

        const sub$ = this.http
            .post<{ fileCreated: string; url: string }>(
                `${this.serverUrl}fito_backup/exporttocsv.php`,
                formdata,
                { headers: headers }
            )
            .subscribe((res) => {
                const result = res;

                if (result.fileCreated) {
                    window.location.replace(`${this.serverUrl}fito_backup/${result.url}`);
                    this.showBackupDialog = false;
                } else {
                    this.showFailure();
                }
                sub$.unsubscribe();
                this.isDownloadingCsv = false;
            });

        const CSV_DOWNLOAD_DELAY = 1500;

        setTimeout(() => {
            this.isDownloadingCsv = false;
        }, CSV_DOWNLOAD_DELAY);
    }

    public getVademecumActivity(): void {
        this.userActivityApi.vademecumActivityGET.safePerform();
        this.userActivityApi.vademecumActivityGET.response(
            (res: VademecumActivity[]) => {
                this.userActivity = res.reverse();
            }
        );
    }

    public downloadVademecumActivity(): void {
        this.isDownloadingCsv = true;

        // Build CSV header (with BOM so Excel opens UTF-8 correctly)
        let csv = 'data:text/csv;charset=' + this.charset +
                    ',\ufeffUsuario;Producto;Referencia;Fecha;Búsqueda;Acción\n';

        // If userActivity is unknown-typed, assert a record
        this.userActivity.forEach((row) => {
            // ✅ Do not mutate `row` (ESLint no-param-reassign compliant)
            const { id, idUsuario, idCliente, ...safeRow } = row;

            // Optional: CSV-escape values (quotes/newlines/;). Keep it if needed.
            const line = Object.values(safeRow)
            .map((v) => {
                const s = String(v ?? '');
                
                return /[;\n"]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
            })
            .join(';');

            csv += line + '\n';
        });

        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;
        
        csvLink.download = 'actividad_vademecum.csv';
        csvLink.href = encodeURI(csv);
        csvLink.click();

        this.isDownloadingCsv = false;
        }


    public showSuccess(): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Perfil actualizado',
            detail: 'Se ha actualizado su perfil con éxito.',
        });
    }

    public showFailure(): void {
        this.messageService.add({
            severity: 'danger',
            summary: 'Error en la descarga',
            detail: 'No se ha podido generar el archivo.',
        });
    }

    public formChanges(tag: string): void {
        if (tag === 'fecha_caducidad') {
            this.fechaEdited = true;
        }
        if (tag === 'uds_medida' && this.currentUser.uds_medida === 'Hectáreas') {
            this.currentUser.ratio_ha = 1;
        }
    }

    public validateForm(): boolean {
        this.validationErrors = '';

        // Sólo aplicar si el usuario tiene el campo `uds_medida` activo.
        if (this.showPerfilUnidades) {
            if (
                this.currentUser.uds_medida !== 'Hectáreas' &&
                (this.currentUser.ratio_ha == null)
            ) {
                this.validationErrors +=
                    '\n- Debe especificar la proporción de ' +
                    this.currentUser.uds_medida +
                    ' respecto a una Hectáreas.';
                return false;
            }
        }

        return true;
    }

    public scrollToTop(): void {
        const elements = document.getElementsByClassName(
            'ui-dialog-content ui-widget-content'
        );

        const SCROLL_DELAY = 100;

        if (elements?.[0]) {
            setTimeout(() => {
                if (elements[0]) {
                    elements[0].scrollTop = 0;
                }
            }, SCROLL_DELAY);
        }
    }

    // Sigpad
    public drawComplete(sigpad: SignaturePad): void {
        this.modelSignature = sigpad.toDataURL('image/png');
    }

    public clearSigPad(sigpad: SignaturePad): void {
        sigpad.clear();
        this.modelSignature = null;
    }

    public async fetchSignature(): Promise<void> {
        const resSignature = await fetch(this.urlSignature);
        const CORRECT_STATUS = 200;

        if (resSignature.status === CORRECT_STATUS) {
            this.hasSignature = true;
            const resBlob = await resSignature.blob();
            const urlCreator = window.URL;
            
            this.signaturePadElement?.fromDataURL(
                urlCreator.createObjectURL(resBlob)
            );
        }
        return;
    }

    /*public autocompleteProducto(pChips: Chip, event: KeyboardEvent) {
          const numRegistros: string[] = [];
          const element: HTMLInputElement = pChips._chipProps.label;
  
          const found: string = numRegistros.find(it => it.indexOf(element.value) === 0) ?? '';
          let totalLength = 0;
          if (found && element.value && (event.key !== 'Backspace')) {
              totalLength = found.length;
              const autocompletedString = found.substring(element.value.length, totalLength - element.value.length);
  
              element.value = found;
              element.setSelectionRange(totalLength - autocompletedString.length, totalLength);
  
              this.hasAutocompleted = true;
          } else {
              this.hasAutocompleted = false;
          }
      }*/

    public saveListadoProductos(): void {
        this.listadoProductos.referencias = (
            this.listadoProductos.productos || []
        ).join(';');
        if (this.listadoProductos.id != null) {
            this.productosApi.listadoVademecum.PUT.safePerform({
                id: this.listadoProductos.id,
                referencias: this.listadoProductos.referencias,
            } as never);
        } else {
            this.productosApi.listadoVademecum.POST.response((res) => {
                if (res?.[0]) {
                    this.listadoProductos.id = res[0].id ?? '';
                }
            });
            this.productosApi.listadoVademecum.POST.safePerform({
                referencias: this.listadoProductos.referencias,
            } as never);
        }
    }

    public pasteListadoProductos(): void {
        window.navigator.clipboard
            .readText()
            .then((value: string) => {
                if (
                    confirm(
                        'Por favor, asegúrese de que está copiando las referencias correctas y' +
                        ' de que éstas estén separadas por una coma (,), un punto y coma (;), un solo espacio o' +
                        ' que cada referencia esté en' +
                        ' una línea separada (por ejemplo, si copia una columna de un archivo Excel).' +
                        '\n\n' +
                        'Texto copiado:' +
                        '\n\n' +
                        value
                    )
                ) {
                    const separadores = [',', ';', ' ', '\n'];
                    const masRepetido = {
                        separador: '',
                        veces: 0,
                    };

                    separadores.forEach((separador) => {
                        const regex = new RegExp(separador, 'g');
                        const count = ((value || '').match(regex) || []).length;

                        if (count > masRepetido.veces) {
                            masRepetido.separador = separador;
                            masRepetido.veces = count;
                        }
                    });

                    if (masRepetido.veces > 0) {
                        const productosAnadidos: string[] = (value || '')
                            .split(masRepetido.separador)
                            .filter((it: string) => it)
                            .map((it: string) => it.trim());

                        this.listadoProductos.productos = (
                            this.listadoProductos.productos || Array.prototype
                        ).concat(productosAnadidos);
                    }
                }
                return;
            })
            .catch((e) => {
                console.log('catch en getPosition: ' + e);
            });
    }

    public printListadoProductos(): void {
        this.isDownloadingCsv = true;
        this.isGeneratingCsv = true;

        const referenciasCSV = (this.productosCSV ?? []).map((it) => it.referencia);
        
        this.listadoProductos.productos?.forEach((prod: string) => {
            if (!referenciasCSV.includes(+prod)) {
                this.formApi.productosMasUsosGET
                    .toPromise({ p3: '"' + prod + '"' } as never)
                    .then((res) => {
                        if (res[0]) {
                            this.productosCSV.push({
                                referencia: prod,
                                usos: res,
                            } as never);
                        } else {
                            this.productosCSV.push({ referencia: prod, usos: [] } as never);
                        }
                        
                        if (
                            this.productosCSV.length ===
                            this.listadoProductos.productos?.length &&
                            this.isDownloadingCsv
                        ) {
                            this.isGeneratingCsv = false;
                            this.saveListadoProductosCSV();
                        }
                        return;
                    })
                    .catch((e) => {
                        console.log('catch en getPosition: ' + e);
                    });
            }
        });
    }

    public saveListadoProductosCSV(): void {
        if (this.productosCSV.length === 0) {
            alert('No se ha guardado ningún producto.');
            return;
        }

        let csvContent = `data:text/csv;charset=${this.charset},\ufeff`;
        const ignored = new Set(['id', 'codigo_actualizacion', 'fecha_ficha']);
        const productosToSave = (this.productosCSV as Array<{ usos: Uso[] }>).map(p => p.usos);
        const patt = /^\d\d?-\d\d?$/;

        // Cabecera desde el primer uso (si existe)
        const firstUso = productosToSave[0]?.[0] ?? ({} as Uso);
        
        Object.keys(firstUso).forEach((key) => {
            if (!ignored.has(key)) {
            csvContent += `${key};`;
            }
        });

        const END_CHARACTER_POSITION = -1;

        csvContent = `${csvContent.slice(0, END_CHARACTER_POSITION)}\n`;

        // Filas
        productosToSave.forEach((grupo) => {
            (grupo as Uso[]).forEach((row) => {
            Object.keys(row).forEach((key) => {
                if (!ignored.has(key)) {
                const raw = (row as Record<string, unknown>)[key];
                let text = raw == null ? '' : String(raw);

                // Evitar que Excel interprete 1-1, 10-2, etc. como fechas
                if (patt.test(text)) {
                    text = `'${text}`;
                }

                const escaped = text.replace(/"/g, '""'); // CSV correcto
                
                csvContent += `"${escaped}";`;
                }
            });

            csvContent = `${csvContent.slice(0, END_CHARACTER_POSITION)}\n`;
            });
        });

        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;
        
        if (csvLink) {
            csvLink.download = 'productos.csv';
            csvLink.href = encodeURI(csvContent);
            csvLink.click();
        }

        this.isDownloadingCsv = false;
    }

    // Pyf
    public verFirma(): void {
        const myWindow = window.open(
            'about:blank',
            '_blank',
            'width=600, height=600'
        );
        
        myWindow?.location.assign(
            environment.serverUrl + 'firmas_asesor/' + this.currentUser.firma
        );
        myWindow?.focus();
    }

    public initSyncDataCoop(): Promise<void> {
        this.iconRefresh = 'fa fa-refresh fa-spin';
        return firstValueFrom(
            this.http.get(environment.serverUrl + 'ws/sincro_inges/sincroniza.php')
        )
            .then((resp) => {
                console.log({ resp });

                alert('Se han actualizado los datos de clientes,fincas,parcelas');
                return;
            })
            .then(async () => {
                await firstValueFrom(
                    this.http.get(
                        environment.serverUrl +
                        'ws/sincro_inges/tratamientos_fito_update.php'
                    )
                );
                alert(
                    'Se han actualizado los datos tareas fitosanitarias y tratamientos fitosanitarias'
                );
                this.iconRefresh = 'fa fa-refresh';
                return;
            })
            .catch(() => {
                console.log('Error en la conexión');
                this.iconRefresh = 'fa fa-refresh';
            });
    }

    onDialogShow(): void {
        document.body.style.overflow = 'hidden'; // Oculta el desbordamiento del cuerpo cuando se muestra el diálogo.
    }

    onDialogHide(): void {
        document.body.style.overflow = ''; // Restaura el estilo original del cuerpo.
    }

    private initFincas(): void {
        this.fincasApi.fincasGET.response((fincas) => {
            fincas.unshift({ label: '...', value: null } as never);
            this.fincas = {
                filtered: fincas.map((it: FincasModel) => ({
                    label: it.nombre,
                    value: it,
                })),
                selected: fincas.find(
                    (it: FincasModel) => +it.id === this.currentUser.id_finca
                ),
                values: [],
            };
            const idx = this.formFields2.map((it) => it.field).indexOf('id_finca');

            (this.formFields2[idx] as ItemInterface<object>).values = this.fincas;
        });
        this.fincasApi.fincasGET.safePerform();
    }

    private setOnlineService(): void {
        this.isOnline = navigator.onLine;

        window.addEventListener('online', () => {
            this.isOnline = true;
        });

        window.addEventListener('offline', () => {
            this.isOnline = false;
        });
    }


    // ---------- Helpers -----------------------------------------------------------

    /** Normalize to a tolerant key: lowercase, trim, remove accents if available. */
    private norm(s: string): string {
        return (s ?? '')
            .normalize?.('NFD')
            .replace(/\p{Diacritic}/gu, '')
            .toLowerCase()
            .trim();
    }

    /** Prefer item.id; fallback to item.label; normalized. */
    private itemKey(mi: MenuItemModel): string {
        return this.norm((mi as any).id ?? (mi as any).label ?? '');
    }

    /** Move the item whose key equals `targetKey` to `toIndex` (clamped). */
    private moveKeyToIndex(arr: MenuItemModel[], targetKey: string, toIndex: number): void {
        const k = this.norm(targetKey);
        const fromIdx = arr.findIndex(mi => this.itemKey(mi) === k);
        
        if (fromIdx < 0) {return;}

        const [item] = arr.splice(fromIdx, 1);
        const safeIndex = Math.max(0, Math.min(toIndex, arr.length));
        
        arr.splice(safeIndex, 0, item as MenuItemModel);
    }

    /**
     * Reorder array according to `desiredOrder` (list of ids/labels).
     * Items not in `desiredOrder` are placed afterwards, preserving original order.
     */
    private reorderByKeys(arr: MenuItemModel[], desiredOrder: string[]): void {
        const orderMap = new Map(desiredOrder.map((v, i) => [this.norm(v), i]));
        
        arr.sort((a, b) => {
            const ai = orderMap.get(this.itemKey(a));
            const bi = orderMap.get(this.itemKey(b));
            
            if (ai === undefined && bi === undefined) {return 0;} // stable: keep original order
            if (ai === undefined) {return 1;} // a goes after b
            if (bi === undefined) {return -1;} // a goes before b
            return ai - bi;
        });
    }

    /** Mounts n8n chat only if appName === 'agrogestSIEX' */
    private mountN8nChatIfNeeded(): void {
      if (environment.appName !== 'agrogestSIEX') {return;}
    
      // Prevent duplicate mounts (HMR / reboots)
      if (Boolean((window as any).__n8nChatMounted)) {return;}
    
      const config: any = {
        webhookUrl: 'https://n8n.locatec-ai.es/webhook/8b18aa1c-b501-49a2-a170-03f85ef41e36/chat',
        defaultLanguage: 'es',
        initialMessages: ['¡Hola! 👋', 'Aquí Locatec. ¿En que podemos ayudarte?'],
        i18n: {
          es: {
            title: '¡Hola! 👋',
            subtitle: 'Estamos aquí para ayudarte las 24h.',
            footer: '',
            getStarted: 'Nueva Conversación',
            inputPlaceholder: 'Escribe tu pregunta..',
          },
        },
        // Optional examples of common flags:
        // mode: 'window',            // or 'fullscreen'
        // showWelcomeScreen: true,
        // loadPreviousSession: true,
      };
    
      createChat(config);
      (window as any).__n8nChatMounted = true;
    }
}
